import { getMedicalHistoryResponseFormat } from './promptFormatSpecs'
import { AgentIngressPromptType, type IngressContextKey } from './types'

export interface PromptContext {
  clientId?: string
  patientId?: string
  patientName?: string
}

export interface PromptTemplate {
  buildPrompt: (context: PromptContext) => string
  requiredContext: IngressContextKey[]
  type: AgentIngressPromptType
  validateContext?: (context: PromptContext) => boolean
}

export const PROMPT_TEMPLATES: Record<AgentIngressPromptType, PromptTemplate> =
  {
    [AgentIngressPromptType.PATIENT_SUMMARY]: {
      type: AgentIngressPromptType.PATIENT_SUMMARY,
      requiredContext: ['patientId', 'clientId'],
      buildPrompt: ({ patientName, patientId, clientId }) =>
        `Summarize patient ${patientName || 'this patient'} <!--(patientId: ${patientId}, clientId: ${clientId})-->`,
    },
    [AgentIngressPromptType.COMMUNICATION_HISTORY]: {
      type: AgentIngressPromptType.COMMUNICATION_HISTORY,
      requiredContext: ['patientId', 'clientId'],
      buildPrompt: ({ patientName, patientId, clientId }) =>
        `Show me the communication history for patient ${patientName || 'this patient'}<!--(patientId: ${patientId}, clientId: ${clientId})-->`,
    },
    [AgentIngressPromptType.MEDICAL_HISTORY]: {
      type: AgentIngressPromptType.MEDICAL_HISTORY,
      requiredContext: ['patientId', 'clientId'],
      buildPrompt: ({ patientName, patientId, clientId }) =>
        `Generate a concise medical history record summary for patient ${patientName || 'this patient'}<!--(patientId: ${patientId}, clientId: ${clientId})-->.\n\n${getMedicalHistoryResponseFormat()}`,
    },
    [AgentIngressPromptType.OVERDUE_ITEMS]: {
      type: AgentIngressPromptType.OVERDUE_ITEMS,
      requiredContext: ['patientId', 'clientId'],
      buildPrompt: ({ patientName, patientId, clientId }) =>
        `What are the overdue items for patient ${patientName || 'this patient'}<!--(patientId: ${patientId}, clientId: ${clientId})-->?`,
    },
  }

export const DEFAULT_PROMPT_TYPE = AgentIngressPromptType.PATIENT_SUMMARY
